module.exports = __webpack_public_path__ + "64d617eaf3f2c6f3f0256985b4ede543.svg";